import { Cirus } from "@/classes/Http";
import { IsNumber, IsString, Max, MaxLength, Min, MinLength, validate } from "class-validator";
import { Message } from "element-ui";

const errorMessages: any = {
    code: 'کد تخفیف الزامی می باشد، حداقل ۳ و حداکثر ۱۰ حرف.',
    remaining: 'مبلغ حداقل 1000 و حداکثر 1000000 می باشد.'
}

export class CreateDiscountBody {
    constructor (body?: CreateDiscountBody) {
        this.code=body?.code;
        this.remaining=body?.remaining;
    }
    @IsString()
    @MinLength(4)
    @MaxLength(10)
    code: string;

    @IsNumber()
    @Min(1000)
    @Max(1000000)
    remaining: number;
}

export async function createDiscount(instance_id: number, params: CreateDiscountBody) {
    params = new CreateDiscountBody(params);
    console.log(params);
    
    const errors = await validate(params);
    if (errors.length>0)  {
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance/${instance_id}/discount`;
    return Cirus.put(path, params);
}